var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgMore(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 38,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#a)",
    fill: "#214ba5"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 11.878,
    cy: 11.878,
    r: 1.878,
    transform: "rotate(90 11.878 11.878)"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 11.878,
    cy: 18.635,
    r: 1.878,
    transform: "rotate(90 11.878 18.635)"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 11.878,
    cy: 25.391,
    r: 1.878,
    transform: "rotate(90 11.878 25.391)"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "a"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    transform: "rotate(90 11.878 11.878)",
    d: "M0 0h37.269v23.756H0z"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMore);
export default __webpack_public_path__ + "static/media/more.b94ea32c85946a15b0b792ca7fb49ecd.svg";
export { ForwardRef as ReactComponent };